// お知らせ・確認をモーダルで出す（window.alert / window.confirm の代わり。2026-11-02）
// 画面に1つだけ置いた GlobalNoticeModal が表示する。React の外（utils など）からも呼べる

export type NoticeRequest = {
  kind: "notice" | "confirm";
  title: string;
  message: string;
  confirmLabel: string;
  danger: boolean;
  resolve: (ok: boolean) => void;
};

let listener: ((request: NoticeRequest) => void) | null = null;
const pending: NoticeRequest[] = [];

// GlobalNoticeModal が表示先として登録する
export function subscribeNotice(fn: (request: NoticeRequest) => void): () => void {
  listener = fn;
  while (pending.length > 0) fn(pending.shift() as NoticeRequest);
  return () => { if (listener === fn) listener = null; };
}

function push(request: NoticeRequest) {
  if (listener) listener(request);
  else pending.push(request);
}

// お知らせ（ボタンは「閉じる」だけ）
export function notify(message: string, title = "お知らせ"): Promise<void> {
  return new Promise((resolve) => {
    push({ kind: "notice", title, message, confirmLabel: "閉じる", danger: false, resolve: () => resolve() });
  });
}

// 確認（「キャンセル」と実行ボタン）。実行なら true
export function askConfirm(options: { title: string; message: string; confirmLabel: string; danger?: boolean }): Promise<boolean> {
  return new Promise((resolve) => {
    push({ kind: "confirm", title: options.title, message: options.message, confirmLabel: options.confirmLabel, danger: options.danger ?? false, resolve });
  });
}
